import { Author, HistoryEntry, HistoryEntryComponent } from '@lib/comment';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { IPurchaseRequisitionHistoryEntry, PurchaseRequisitionAction } from './IPurchaseRequisitionHistoryEntry';
import { PurchaseRequisitionStatus } from './PurchaseRequisitionStatus';
import { I18nService } from '@lib/i18n';
import { Observable } from 'rxjs';

export class PurchaseRequisitionHistoryEntry extends HistoryEntry {
    private readonly status: PurchaseRequisitionStatus;
    private readonly action: PurchaseRequisitionAction;

    constructor(
        dto: IPurchaseRequisitionHistoryEntry,
        currentlyLoggedInUserId: string,
        private readonly _i18n: I18nService,
    ) {
        super(
            dto.comment,
            HistoryEntryComponent,
            dto.author ? new Author(dto.author.id, dto.author.firstname, dto.author.lastname) : undefined,
            dto.timestamp,
            currentlyLoggedInUserId,
            dto.superUser ? new Author(dto.superUser.id, dto.superUser.firstname, dto.superUser.lastname) : undefined,
        );
        this.status = new PurchaseRequisitionStatus(dto.status);
        this.action = dto.action;
    }

    public get statusText(): string {
        return this.status.statusText;
    }

    public get statusColor(): string {
        return this.status.textColor;
    }

    public override get actionText$(): Observable<string> {
        switch (this.action) {
            case PurchaseRequisitionAction.CREATED:
                return this._i18n.translateSingle(marker('Der Bedarf wurde von {{author}} gemeldet.'), {
                    author: this.author,
                });
            case PurchaseRequisitionAction.APPROVED:
                return this._i18n.translateSingle(marker('Die Bedarfsmeldung wurde von {{author}} freigegeben.'), {
                    author: this.author,
                });
            case PurchaseRequisitionAction.REJECTED:
                if (this.author) {
                    return this._i18n.translateSingle(marker('Die Bedarfsmeldung wurde von {{author}} abgelehnt.'), {
                        author: this.author,
                    });
                } else {
                    return this._i18n.translateSingle(marker('Die Bedarfsmeldung wurde abgelehnt.'));
                }
            case PurchaseRequisitionAction.WITHDRAWN:
                return this._i18n.translateSingle(marker('{{author}} hat die Bedarfsmeldung zurückgezogen.'), {
                    author: this.author,
                });
            case PurchaseRequisitionAction.TO_BE_REWORKED:
                return this._i18n.translateSingle(
                    marker('Der Bedarfsträger wurde von {{author}} zur Überarbeitung der Bedarfsmeldung aufgefordert.'),
                    { author: this.author },
                );
            case PurchaseRequisitionAction.APPROVER_CHOSEN:
                return this._i18n.translateSingle(
                    marker('Der Bedarfsträger {{author}} hat einen Freigeber ausgewählt.'),
                    { author: this.author },
                );
            case PurchaseRequisitionAction.RESULT_DOCUMENT_SELECTED:
                return this._i18n.translateSingle(marker('{{author}} hat das Resultat der Bedarfsmeldung geändert.'), {
                    author: this.author,
                });
            case PurchaseRequisitionAction.REWORKED:
                return this._i18n.translateSingle(
                    marker('Der Bedarf wurde vom Bedarfsträger {{author}} überarbeitet.'),
                    { author: this.author },
                );
        }
    }
}
